import { render } from "./CaseStudyGTC.vue?vue&type=template&id=fb0da3be"
import script from "./CaseStudyGTC.vue?vue&type=script&lang=js"
export * from "./CaseStudyGTC.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__